export { default } from "./OngoingOrderSkeleton.jsx";
